import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { FirebaseService } from '../../services/firebase.service';
import { SnackBarService } from '../../services/snack-bar.service';

@Component({
  selector    : 'sign-in-up',
  templateUrl : 'sign-in-up.html',
  styleUrls   : [ 'sign-in-up.scss' ]
})

export class SignInUpComponent implements OnInit {
  isSignup : boolean = true;
  email    : string;
  password : string;
  confirm  : string;
  error    : {} = {};
  loading  : boolean = false;
  snackMsg : Object = { delay : 7500 }; // increase snack delay to ensure time to read sign in/up messages

  constructor(
    private firebaseService : FirebaseService,
    private snackBarService : SnackBarService,
    private router          : Router,
    private route           : ActivatedRoute
  ) {}

  ngOnInit() : void {
    this.route.url
      .take(1)
      .map(urlSegment => urlSegment[0].path === 'signup')
      .subscribe(isSignup => this.isSignup = isSignup);
  }

  // sign in/up with Google/FB
  private providerLogin(isGoogle : boolean = true) : void {
    this.loading = true;

    // first, clear all previous errors
    this.resetErrors();

    this.firebaseService.providerLogin(isGoogle)
      .then(response => this.handleResponse(response));
  }

  private emailSignInUp() : void {
    this.loading = true;

    // first, clear all previous errors
    this.resetErrors();

    if (this.isSignup && this.password !== this.confirm) {
      this.snackMsg['message'] = 'Passwords don\'t match';

      this.assignError(['password', 'confirm']);
      this.clearField(['password', 'confirm']);

      this.snackBarService.show(this.snackMsg);
    } else {
      this.firebaseService.emailSignInUp(this.email, this.password, this.isSignup)
        .then(response => this.handleResponse(response));
    }
  }

  private handleResponse(response) : void {
    if (response && response.lastList)
      this.postSignIn(response);
    else {
      this.handleError(response.code);
    }
  }

  private handleError(errorCode : string) : void {
    switch (errorCode) {
      case 'auth/email-already-in-use':
        this.snackMsg['message'] = 'Email address is already in use';

        this.assignError(['email']);
        this.clearField(['email']);
      break;

      case 'auth/weak-password':
        this.snackMsg['message'] = 'Password should be at least 6 characters';

        this.assignError(['password', 'confirm']);
        this.clearField(['password', 'confirm']);
      break;

      case 'auth/user-not-found':
      case 'auth/wrong-password':
        this.snackMsg['message'] = 'Email and/or password is incorrect';

        this.assignError(['email', 'password']);
      break;

      case 'auth/wrong-provider':
        this.snackMsg['message'] = `Try signing ${ this.isSignup ? 'up' : 'in' } via Google`;

        this.clearField(['email', 'password']);
      break;

      case 'auth/account-exists-with-different-credential':
        // in the case of attempting FB login using credentials associated with a Goog acct
        // a silent error is thrown somewhere I am unable to track down
        // the code here will fire, ie console.debug('whatever') will show up
        // however, no action code seems to work:
        // no attempt to set loading to false, display a snackbar message, or route away from the view will work
        // I do not know why and I have tried many days to debug/fix this
        // at this point I'm leaving this alone
        // my hope is that this bug is marginal and unlikely to be encountered in prod
        // I hope

        console.info('You have encountered a bug :(');
      break;

      case 'auth/popup-closed-by-user':
        // the delayed nature of the external window closed callback
        // prevents this snackbar from firing
        // unclear why, exactly
        this.snackMsg['message'] = `Try signing ${ this.isSignup ? 'up' : 'in' } again`;
      break;

      default:
        // unknown error code
        console.log('unknown error code: ', errorCode);

        this.snackMsg['message'] = 'Unknown Error :/';
      break;
    }

    // remove loading
    this.loading = false;

    // show error message
    this.snackBarService.show(this.snackMsg);
  }

  private clearField(customArr : string[] = ['email', 'password', 'confirm']) : void {
    for (const field of customArr)
      this[field] = null;
  }

  private resetErrors() : void {
    this.assignError();

    // reset generic, default message
    this.snackMsg['message'] = 'Uh oh! Something went wrong';
  }

  private assignError(customArr : string[] = []) : void {
    this.error = {};

    for (const field of customArr)
      this.error[field] = true;
  }

  private postSignIn(user) : void {
    this.clearField();

    this.router.navigate([user.lastList.type, user.lastList.listID]);
  }
}


// WEBPACK FOOTER //
// /Users/briznad/Documents/WebDev/personal/cartmigo/cartmigo-dev/src/app/components/sign-in-up/sign-in-up.ts